export default "__VITE_ASSET__BXjdZXDw__"